module.exports = __webpack_public_path__ + "static/media/art67.e8d135df.jpg";